import { useQuery } from '@tanstack/react-query'
import { desilApi } from '../lib/client'
import { ApiResponse, DesilStatistics } from '../../../shared-lib/types'

export function useDesilStats() {
    return useQuery<ApiResponse<DesilStatistics>>({
        queryKey: ['desil', 'statistics'],
        queryFn: async () => {
            try {
                return await desilApi.getStats()
            } catch (error) {
                // Create structured error response
                const errorResponse: ApiResponse<DesilStatistics> = {
                    status: "error",
                    message: error instanceof Error ? error.message : "Gagal mengambil data statistik desil",
                    data: {
                        totalRecords: 0,
                        latestTahap: null,
                        latestTahun: null,
                        earliestTahun: null,
                        totalKpm: 0,
                        totalDesil1: 0,
                        totalDesil2: 0,
                        totalDesil3: 0,
                        totalDesil4: 0,
                        totalDesil5: 0,
                        totalDesil6_10: 0,
                        totalBelumDiperingkat: 0,
                        grandTotal: 0,
                        avgDesil1: 0,
                        avgDesil2: 0,
                        avgDesil3: 0,
                        avgDesil4: 0,
                        avgDesil5: 0,
                        avgDesil6_10: 0,
                        avgBelumDiperingkat: 0,
                        yearlyTrend: []
                    }
                }
                
                console.error('Error fetching desil statistics:', error)
                throw errorResponse
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
    })
}